export { Navbar } from './navbar'
export { HeroSection } from './hero-section'
export { LogosStrip } from './logos-strip'
export { AboutSection } from './about-section'
export { ProcessSection } from './process-section'
export { ServicesSection } from './services-section'
export { PortfolioSection } from './portfolio-section'
export { TestimonialsSection } from './testimonials-section'
export { PricingSection } from './pricing-section'
export { TeamSection } from './team-section'
export { FaqSection } from './faq-section'
export { ContactSection } from './contact-section'
export { Footer } from './footer'
